import { jsx as _jsx } from "react/jsx-runtime";
export const IconSetting = props => /*#__PURE__*/_jsx("svg", {
  width: 16,
  height: 16,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    // eslint-disable-next-line max-len
    d: "M11.5 2 15 8.063l-3.5 6.062h-7L1 8.063 4.5 2h7Zm-.578 1H5.077L2.155 8.064l2.922 5.06h5.845l2.924-5.06L10.922 3ZM8 6.064a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0 1a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2Z",
    fillRule: "evenodd"
  })
});
//# sourceMappingURL=es/Icon/Setting.js.map